import { ColumnsType } from 'antd/es/table'
import BaseTable from '.'
import { Flex, Tooltip } from 'antd'
import classNames from 'classnames'

interface IBaseExtraTableProps<T> {
  className?: string
  columns: ColumnsType<T>
  data: any
  headers: { label: string; width?: number; isFlexEnd?: boolean; description?: string }[]
  loading: boolean
  isDepHead?: boolean
  depName?: string
  staffName?: string
  isModalcroll?: boolean
  scroll?: {
    x?: number | true | string
    y?: number | string
  }
}

const BaseExtraTable = <T extends object>({
  columns,
  data,
  scroll,
  headers,
  className,
  loading,
  isDepHead,
  depName,
  staffName,
  isModalcroll = false
}: IBaseExtraTableProps<T>) => {
  return (
    <div className={classNames('extra-table', className)}>
      <Flex className='flex-col mt-5'>
        <Flex className='bg-primary-50 border border-b-0 border-solid rounded-t-lg border-neutral-border-light overflow-hidden'>
          {isDepHead ? (
            <div className={classNames('box-border font-[650] text-sm p-3')}>
              {`${depName} ${staffName ? ' - ' + staffName : ''}`}
            </div>
          ) : (
            headers.map((header, i) => (
              <div
                key={i}
                style={{
                  width: header.width || 'auto'
                }}
                className={classNames('box-border font-[650] text-sm p-3 last:bg-positive-200', {
                  '[&:nth-last-child(2)]:flex-1': headers.length > 2 && !!header?.isFlexEnd
                })}
              >
                {header.description ? (
                  <>
                    <Tooltip title={header.label} placement={'top'}>
                      <p className='truncate'>{header.label}</p>
                    </Tooltip>
                    <Tooltip title={header.description} placement={'top'}>
                      <p className='italic font-medium truncate'>{header.description}</p>
                    </Tooltip>
                  </>
                ) : (
                  <Tooltip title={header.label} placement={'top'}>
                    <p className='flex items-center h-full truncate'>{header.label}</p>
                  </Tooltip>
                )}
              </div>
            ))
          )}
        </Flex>
        <BaseTable<T>
          loading={loading}
          columns={columns}
          showPagination={false}
          total={data?.length}
          dataSource={data}
          page={1}
          rowsPerPage={data?.length || 0}
          scroll={isModalcroll ? { x: 'max-content', ...(data?.length > 4 ? { y: 'calc(60vh)' } : {}) } : scroll || {}}
        />
      </Flex>
    </div>
  )
}

export default BaseExtraTable
